import { render } from "./Footer.vue?vue&type=template&id=a775d87a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a775d87a&scoped=true&lang=less"

import exportComponent from "F:\\luyou\\luyou_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a775d87a"]])

export default __exports__